import { render } from "./okr.vue?vue&type=template&id=6fd9ed9a"
import script from "./okr.vue?vue&type=script&lang=js"
export * from "./okr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__